import { c as _c } from "react/compiler-runtime";
import { Modal, ModalBody, ModalFooter, ModalFooterButton, ModalHeader, ModalHeaderTitle, TextBody } from "@opensea/ui-kit";
import { WarningFilled } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
export function SmartContractWalletWarningModal(t0) {
  const $ = _c(39);
  const {
    open,
    onContinue,
    onCancel
  } = t0;
  const t = useTranslations("wallet.SmartContractWalletWarningModal");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <WarningFilled className="inline-block" fill="warning" size={24} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <ModalHeader className="gap-2">{t1}<ModalHeaderTitle>{t2}</ModalHeaderTitle></ModalHeader>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("warning");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <TextBody>{t4}</TextBody>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("warningBold");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <TextBody weight="semibold">{t6}</TextBody>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = <ModalBody>{t5}{t7}</ModalBody>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("cancel");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== onCancel || $[19] !== t9) {
    t10 = <ModalFooterButton onClick={onCancel} variant="secondary">{t9}</ModalFooterButton>;
    $[18] = onCancel;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("continue");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== onContinue || $[24] !== t11) {
    t12 = <ModalFooterButton onClick={onContinue} variant="destructive">{t11}</ModalFooterButton>;
    $[23] = onContinue;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t10 || $[27] !== t12) {
    t13 = <ModalFooter>{t10}{t12}</ModalFooter>;
    $[26] = t10;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13 || $[30] !== t3 || $[31] !== t8) {
    t14 = <>{t3}{t8}{t13}</>;
    $[29] = t13;
    $[30] = t3;
    $[31] = t8;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== onCancel) {
    t15 = open_0 => {
      if (!open_0) {
        onCancel();
      }
    };
    $[33] = onCancel;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== open || $[36] !== t14 || $[37] !== t15) {
    t16 = <Modal content={t14} onOpenChange={t15} open={open} />;
    $[35] = open;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
}